/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoShareNoteInput = {
    clientMutationId?: string | null;
    slug: string;
    roles: Array<string>;
    entitySlug: string;
    entityType: string;
};
export type ShareNoteMutationVariables = {
    input: infoShareNoteInput;
};
export type ShareNoteMutationResponse = {
    readonly infoShareNote: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShareNoteMutation = {
    readonly response: ShareNoteMutationResponse;
    readonly variables: ShareNoteMutationVariables;
};



/*
mutation ShareNoteMutation(
  $input: infoShareNoteInput!
) {
  infoShareNote(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoShareNotePayload",
    "kind": "LinkedField",
    "name": "infoShareNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareNoteMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareNoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "896c6324540802af2c3f3911d4746a09",
    "id": null,
    "metadata": {},
    "name": "ShareNoteMutation",
    "operationKind": "mutation",
    "text": "mutation ShareNoteMutation(\n  $input: infoShareNoteInput!\n) {\n  infoShareNote(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ff74364fee5fd03387d04cdd2ff4903e';
export default node;
